export default __webpack_public_path__ + "static/media/mini_newrelic_dark.22bcb686.svg";